import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const TanningBed = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="tanning-bed"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M57.5814 24.2081C58.1372 24.0264 58.1476 24.0434 57.5628 24.0434H3.43561C2.85191 24.0434 2.86342 24.0264 3.41746 24.2081C7.63547 25.5917 8.99344 35.2649 9.33321 38.505C9.39409 39.086 9.3901 39.5581 9.34163 39.5581C9.29315 39.5581 9.7281 39.5581 10.3116 39.5581H50.5111C51.0948 39.5581 51.6041 39.086 51.665 38.505C52.0052 35.266 53.3625 25.59 57.5814 24.2081ZM48.2191 34.2686H11.5463C10.9626 34.2686 10.4884 33.796 10.4884 33.2108C10.4884 32.6255 10.9628 32.1529 11.5463 32.1529H48.2191C48.8027 32.1529 49.2769 32.6255 49.2769 33.2108C49.2769 33.796 48.8025 34.2686 48.2191 34.2686ZM48.2191 28.4504H11.5463C10.9626 28.4504 10.4884 27.9779 10.4884 27.3926C10.4884 26.8074 10.9628 26.3348 11.5463 26.3348H48.2191C48.8027 26.3348 49.2769 26.8074 49.2769 27.3926C49.2769 27.9779 48.8025 28.4504 48.2191 28.4504Z"
          fill={fill}
        />
        <path
          d="M20.7145 50.1358H21.5957H41.0786C42.5395 50.1358 43.7232 48.9518 43.7232 47.4913C43.7232 46.0304 42.5392 44.8467 41.0786 44.8467H20.7145C19.4356 44.8467 18.3684 45.7549 18.1225 46.9625H10.0482C9.17119 46.9625 8.46155 47.6733 8.46155 48.5494C8.46155 49.4253 9.17141 50.136 10.0482 50.136H20.7145V50.1358Z"
          fill={fill}
        />
        <path
          d="M48.3955 50.1357C50.5379 50.1357 52.2746 48.399 52.2746 46.2566C52.2746 44.1142 50.5379 42.3774 48.3955 42.3774C46.2531 42.3774 44.5164 44.1142 44.5164 46.2566C44.5164 48.399 46.2531 50.1357 48.3955 50.1357Z"
          fill={fill}
        />
        <path
          d="M4.67004 51.8991C4.67004 52.4848 5.14439 52.957 5.72787 52.957H54.0369C54.6206 52.957 55.0948 52.4848 55.0948 51.8991C55.0948 51.3143 54.6204 50.8413 54.0369 50.8413H5.72809C5.14439 50.8413 4.67004 51.3157 4.67004 51.8991Z"
          fill={fill}
        />
      </g>
      <circle cx="8.10279" cy="11.4999" r="3.47059" fill={fill} stroke={stroke} />
      <line x1="8.04395" y1="19" x2="8.04395" y2="17.2353" stroke={stroke} />
      <line x1="8.04395" y1="5.76465" x2="8.04395" y2="3.99994" stroke={stroke} />
      <line x1="2.29064" y1="7.17469" x2="3.72659" y2="8.20046" stroke={stroke} />
      <line x1="13.0603" y1="14.868" x2="14.4962" y2="15.8938" stroke={stroke} />
      <line x1="1.78011" y1="16.0061" x2="3.19775" y2="14.9551" stroke={stroke} />
      <line x1="12.4123" y1="8.12373" x2="13.83" y2="7.07278" stroke={stroke} />
      <defs>
        <clipPath id="clip0">
          <rect width="55" height="55.0002" fill="white" transform="translate(3 1)" />
        </clipPath>
      </defs>
    </svg>
  );
};
/* eslint-enable max-len */

TanningBed.defaultProps = {
  className: null,
};

TanningBed.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default TanningBed;
